import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";

const useHideBanners = () => {
  const { getSender, isHiddenBanners } = useMail();
  const { isPro, isBusiness, isPremium } = useUser();

  return (
    getSender().hasBusinessPackage ||
    isPro() ||
    isBusiness() ||
    isPremium() ||
    isHiddenBanners()
  );
};

export default useHideBanners;
